<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 15:03:16
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-11-21 14:54:31
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/ImageFrameAndEndUpload.vue
-->
<template>
    <div class="mt-4">
        <div class="flex items-center justify-between mb-3 gap-2">
            <label class="text-white text-sm font-semibold">
                {{ t('tools.imageLabel') }}
            </label>
            <div class="flex justify-center items-center gap-[10px]">
                <span
                    class="text-sub-title flex items-center justify-between text-sm leading-5"
                >
                    {{ t('tools.addEndFrame') }}
                </span>
                <button
                    @click="frame_end_mode = !frame_end_mode"
                    type="button"
                    role="switch"
                    :aria-checked="frame_end_mode"
                    :aria-label="t('tools.addEndFrame')"
                    class="relative inline-flex h-4 w-7 items-center rounded-full transition-all duration-300"
                    :class="frame_end_mode ? 'bg-switch-active-bg'
                                    : 'bg-white/10'"
                >
                    <span
                        class="inline-block h-3 w-3 transform rounded-full transition-transform"
                        :class="
                            !frame_end_mode
                                ? 'translate-x-0.5 bg-white'
                                : 'translate-x-3.5 bg-switch-active-dot'
                        "
                    ></span>
                </button>
            </div>
        </div>

        <div class="flex items-center justify-center gap-2 mb-[10px]">
            <div
                @click="triggerFirstFileUpload"
                @dragover.prevent
                @drop.prevent="handleFirstFileDrop"
                class="flex-1 bg-tool-default-black border border-white/[.06] group text-sub-title hover:text-white hover:border-white/30 cursor-pointer relative flex flex-col gap-[10px] items-center justify-center h-[135px] rounded-[10px] "
            >
                <div
                    v-if="!first_image_url && !firstUploading"
                    class="flex flex-col items-center justify-center gap-[10px]"
                >
                    <ui-upload-icon :hoverable="true" />

                    <p
                        class="text-sm text-sub-title group-hover:text-white px-5 text-center"
                    >
                        {{ t('tools.first_upload') }}
                    </p>

                    <input
                        ref="firstFileInput"
                        type="file"
                        multiple
                        accept="image/*"
                        @change="handleFirstFileSelect"
                        class="hidden"
                    />
                </div>

                <l-dot-spinner
                    v-else-if="firstUploading && isClient"
                    size="40"
                    speed="0.9"
                    color="var(--el-menu-active-color)"
                ></l-dot-spinner>
                <div v-else class="max-h-[90%] max-w-[90%]">
                    <img
                        :src="first_image_url"
                        class="h-full w-full"
                        alt="first keyframe url"
                    />
                </div>
                <button
                    v-if="first_image_url"
                    type="button"
                    :aria-label="
                        t('common.remove') ||
                        t('common.delete') ||
                        'Remove image'
                    "
                    class="inline-flex rounded-full items-center justify-center whitespace-nowrap text-base font-medium ring-offset-background duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground absolute z-[2] top-1 right-1 h-[22px] w-[22px] bg-[#2E2E2E] text-white group-hover:opacity-100 transition-opacity"
                    @click.stop="first_image_url = ''"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="13"
                        viewBox="0 0 12 13"
                        fill="none"
                        class="w-3 h-3"
                    >
                        <path
                            d="M9 3.68164L3 9.68164"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M3 3.68164L9 9.68164"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>
            <div @click="exchangeImage()">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    class="w-6 h-6 cursor-pointer text-sub-title hover:text-text-active"
                >
                    <path
                        d="M22.4601 9.79L18.4601 5.79C18.3669 5.69676 18.2562 5.6228 18.1344 5.57234C18.0126 5.52188 17.882 5.49591 17.7501 5.49591C17.4838 5.49591 17.2284 5.6017 17.0401 5.79C16.8518 5.97831 16.746 6.2337 16.746 6.5C16.746 6.7663 16.8518 7.0217 17.0401 7.21L19.3401 9.5H7.75014C7.48492 9.5 7.23057 9.60536 7.04303 9.7929C6.8555 9.98043 6.75014 10.2348 6.75014 10.5C6.75014 10.7652 6.8555 11.0196 7.04303 11.2071C7.23057 11.3946 7.48492 11.5 7.75014 11.5H21.7501C21.9476 11.499 22.1403 11.4396 22.304 11.3293C22.4677 11.2189 22.5951 11.0626 22.6701 10.88C22.7467 10.6979 22.7676 10.4972 22.7303 10.3032C22.6929 10.1092 22.5989 9.93063 22.4601 9.79ZM17.7501 13.5H3.75014C3.55271 13.501 3.36 13.5604 3.19628 13.6707C3.03256 13.7811 2.90516 13.9374 2.83014 14.12C2.75356 14.3021 2.73264 14.5028 2.77001 14.6968C2.80739 14.8908 2.90138 15.0694 3.04014 15.21L7.04014 19.21C7.1331 19.3037 7.2437 19.3781 7.36556 19.4289C7.48742 19.4797 7.61813 19.5058 7.75014 19.5058C7.88215 19.5058 8.01286 19.4797 8.13472 19.4289C8.25658 19.3781 8.36718 19.3037 8.46014 19.21C8.55387 19.117 8.62826 19.0064 8.67903 18.8846C8.7298 18.7627 8.75594 18.632 8.75594 18.5C8.75594 18.368 8.7298 18.2373 8.67903 18.1154C8.62826 17.9936 8.55387 17.883 8.46014 17.79L6.16014 15.5H17.7501C18.0154 15.5 18.2697 15.3946 18.4572 15.2071C18.6448 15.0196 18.7501 14.7652 18.7501 14.5C18.7501 14.2348 18.6448 13.9804 18.4572 13.7929C18.2697 13.6054 18.0154 13.5 17.7501 13.5Z"
                        fill="currentColor"
                    />
                </svg>
            </div>
            <div
                @click="triggerLastFileUpload"
                @dragover.prevent
                @drop.prevent="handleLastFileDrop"
                class="flex-1 bg-tool-default-black border border-white/[.06] group text-sub-title hover:text-white hover:border-white/30 relative cursor-pointer flex flex-col gap-[10px] items-center justify-center h-[135px] rounded-[10px] "
            >
                <div
                    v-if="!last_image_url && !lastUploading"
                    class="flex flex-col gap-[10px] items-center justify-center"
                >
                    <ui-upload-icon :hoverable="true" />

                    <p
                        class="text-sm text-sub-title group-hover:text-white px-5 text-center"
                    >
                        {{ t('tools.last_upload') }}
                    </p>

                    <input
                        ref="lastFileInput"
                        type="file"
                        multiple
                        accept="image/*"
                        @change="handleLastFileSelect"
                        class="hidden"
                    />
                </div>
                <l-dot-spinner
                    v-else-if="lastUploading && isClient"
                    size="40"
                    speed="0.9"
                    color="var(--el-menu-active-color)"
                ></l-dot-spinner>
                <div v-else class="max-h-[90%] max-w-[90%] relative">
                    <img
                        :src="last_image_url"
                        class="h-full w-full"
                        alt="last keyframe url"
                    />
                </div>
                <button
                    v-if="last_image_url"
                    type="button"
                    :aria-label="
                        t('common.remove') ||
                        t('common.delete') ||
                        'Remove image'
                    "
                    @click.stop="last_image_url = ''"
                    class="inline-flex rounded-full items-center justify-center whitespace-nowrap text-base font-medium ring-offset-background duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:text-accent-foreground absolute z-[2] top-1 right-1 h-[22px] w-[22px] bg-[#2E2E2E] text-white group-hover:opacity-100 transition-opacity"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="13"
                        viewBox="0 0 12 13"
                        fill="none"
                        class="w-3 h-3"
                    >
                        <path
                            d="M9 3.68164L3 9.68164"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M3 3.68164L9 9.68164"
                            stroke="white"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </button>
            </div>
        </div>
        <div class="text-sub-title text-xs flex gap-1 ml-1 items-center mt-1">
            <el-icon class="!text-sm"><Warning /></el-icon>
            {{ t('upload.errors.fileTooLarge', { maxSize: 10 }) }}
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'
import { Warning } from '@element-plus/icons-vue'
import { useI18n } from '@/composables/useI18n'
import { debounce, noticeMessagePopup, getMaxImageSize } from '@/utils/common'
import { showLoginModal } from '~/utils/emitter'
import axios from 'axios'
import { useUserStore } from '~/stores/user'

const { t, locale } = useI18n()
const userStore = useUserStore()
const isLoggedIn = computed(() => userStore.isLoggedIn)

const first_image_url = defineModel('first_image_url', {
    type: String,
    default: '',
})
const last_image_url = defineModel('last_image_url', {
    type: String,
    default: '',
})

const frame_end_mode = defineModel('frame_end_mode', {
    type: Boolean,
    default: false,
})

const firstUploading = ref(false)
const lastUploading = ref(false)
const firstFileInput = ref<HTMLInputElement | null>(null)
const lastFileInput = ref<HTMLInputElement | null>(null)
const is_exchange_image = ref(false)
const uploadFirstFileList = ref<File[]>([])
const uploadLastFileList = ref<File[]>([])
const isClient = ref(false)

const triggerFirstFileUpload = () => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    firstFileInput.value?.click()
}
const triggerLastFileUpload = () => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    lastFileInput.value?.click()
}
const handleFirstFileDrop = (event: DragEvent) => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    const files = event.dataTransfer?.files
    if (files) {
        const fileArray = Array.from(files)
        handleFirstAutoBatchUpload(fileArray)
    }
}

const handleLastFileDrop = (event: DragEvent) => {
    if (!isLoggedIn.value) {
        showLoginModal()
        return
    }
    const files = event.dataTransfer?.files
    if (files) {
        const fileArray = Array.from(files)
        handleLastAutoBatchUpload(fileArray)
    }
}

const handleFirstFileSelect = (event: Event) => {
    const target = event.target as HTMLInputElement
    const files = target.files as FileList
    const fileArray = Array.from(files)
    handleFirstAutoBatchUpload(fileArray)
}

const handleLastFileSelect = (event: Event) => {
    const target = event.target as HTMLInputElement
    const files = target.files as FileList
    const fileArray = Array.from(files)
    handleLastAutoBatchUpload(fileArray)
}

// @ts-ignore
const config = useRuntimeConfig()
let token = ''
let language = ''
const handleFirstAutoBatchUpload = debounce(async (fileList: File[]) => {
    if (!fileList?.length) return

    // 校验文件大小（限制为10MB）
    for (const file of fileList) {
        if (!getMaxImageSize(file, 10)) {
            // 文件大小超过限制，显示错误提示
            noticeMessagePopup(
                t('upload.errors.fileTooLarge', { maxSize: 10 }),
                t('common.tip'),
                'error',
                3000,
                ''
            )
            // 重置 input 值，允许再次选择相同文件
            if (firstFileInput.value) {
                firstFileInput.value.value = ''
            }
            return
        }
    }

    uploadFirstFileList.value = fileList

    // set skeleton screen number
    const formData = new FormData()
    uploadFirstFileList.value.forEach((fileObj: File) => {
        formData.append('files', fileObj)
    })
    firstUploading.value = true
    try {
        // @ts-ignore
        if (import.meta.client) {
            token = localStorage.getItem('token') || ''
            // 请求语言跟随当前 URL 的 locale，而不是偏好/旧的 localStorage('language')
            language = locale.value || 'en'
        }
        const url = new URL(
            config.public.apiBase + '/api/v1/auth/s3/upload_images'
        )
        url.searchParams.append('app_key', config.public.appKey)

        const res = await axios.post(url.toString(), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: token,
                'Accept-Language': language,
            },
        })
        const { data, status } = res.data
        if (status === 200) {
            first_image_url.value = data?.object_url_list?.[0]
            firstUploading.value = false
        } else if ([1005, 4001, 4002].includes(status)) {
            showLoginModal()
        }
    } catch (err) {
        console.error('upload failed:', err)
    } finally {
        firstUploading.value = false
    }
}, 500)

const handleLastAutoBatchUpload = debounce(async (fileList: File[]) => {
    if (!fileList?.length) return

    // 校验文件大小（限制为10MB）
    for (const file of fileList) {
        if (!getMaxImageSize(file, 10)) {
            // 文件大小超过限制，显示错误提示
            noticeMessagePopup(
                t('upload.errors.fileTooLarge', { maxSize: 10 }),
                t('common.tip'),
                'error',
                3000,
                ''
            )
            // 重置 input 值，允许再次选择相同文件
            if (lastFileInput.value) {
                lastFileInput.value.value = ''
            }
            return
        }
    }
    uploadLastFileList.value = fileList

    // set skeleton screen number
    const formData = new FormData()
    uploadLastFileList.value.forEach((fileObj: File) => {
        formData.append('files', fileObj)
    })
    lastUploading.value = true
    try {
        const url = new URL(
            config.public.apiBase + '/api/v1/auth/s3/upload_images'
        )
        url.searchParams.append('app_key', config.public.appKey)

        const res = await axios.post(url.toString(), formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: localStorage?.getItem('token'),
                // 请求语言跟随当前 URL 的 locale
                'Accept-Language': locale.value || 'en',
            },
        })
        const { data, status } = res.data
        if (status === 200) {
            last_image_url.value = data?.object_url_list?.[0]
            lastUploading.value = false
        }
    } catch (err) {
        console.error('upload failed:', err)
    } finally {
        lastUploading.value = false
    }
}, 500)

const exchangeImage = () => {
    if (!first_image_url.value && !last_image_url.value) return
    const temp_ = first_image_url.value
    first_image_url.value = last_image_url.value
    last_image_url.value = temp_
}

// 只在客户端注册 ldrs
onMounted(async () => {
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
            // 确保注册完成后再设置 isClient，避免组件在注册前渲染
            isClient.value = true
        } catch (error) {
            console.error('Failed to load ldrs:', error)
            // 即使加载失败也设置为 true，避免无限等待
            isClient.value = true
        }
    }
})
</script>
<style scoped lang="less"></style>
